import { render, staticRenderFns } from "./EditarTitulo.vue?vue&type=template&id=c4f23640&scoped=true"
import script from "./EditarTitulo.vue?vue&type=script&lang=js"
export * from "./EditarTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f23640",
  null
  
)

export default component.exports